;(function($, undefined){
    var rnn, log, titleVal, tally;

    function initAvatarSelectors() {

        function setDefaultAvatar(value) {
            var prefix1 = (value !== 'M') ? '' : 'fe';
            var prefix2 = (value !== 'M') ? 'fe' : '';
            $('.default-avatar-' + prefix1 + 'male').addClass('hide');
            $('.default-avatar-' + prefix2 + 'male').removeClass('hide');
        }

        if ($('.profileForm').length > 0) {
            $('input[name="gender"]').change(function () {
                setDefaultAvatar($(this, ':checked').val());
            });
            setDefaultAvatar($('input[name="gender"]:checked').val());
        }
    }

    function initEmailConfirmationAlerts() {
        $('.emailConfirmationAlert').each(function () {
            var $alert = $(this);

            $alert.on('click', 'a', function (event) {
                var $link = $(this);

                event.preventDefault();
                $.get($link.data('url'), function (response) {
                    response = $.parseJSON(response);
                    if (response) {
                        $link
                        .closest('.emailConfirmationAlertMessage')
                            .html('Please check your email, a confirmation email has been sent to your inbox.');
                        $alert
                        .removeClass('alert-error alert-danger')
                        .addClass('alert-success');
                    }
                });
            });
        });
    }

    function initialiseTopicSearch() {
        var $topicsForm = $('#topics-search-form');
        var topicsAction = $topicsForm.attr('action');
        var topicsUrls = $topicsForm.data('typeahead-topics-url');

        if( $topicsForm.length < 1 ){ return; }
        $topicsForm.on('submit', function(e) {
            e.preventDefault();
        });

        if( !topicsUrls ){ return; }
        $.getJSON(topicsUrls, function (data) {
            $topicsForm.find('input[name=topic]').typeahead({
                source: data,
                menu: '<ul id="typeahead-topic-menu" class="typeahead dropdown-menu"></ul>',
                updater: function(item) {
                    window.location = topicsAction + item;
                    return item;
                }
            });
        });
    }

    function populateMyEvents() {
        var eventsTabEl = document.getElementById('js-events-tab');
        if(eventsTabEl && eventsTabEl.classList.contains('active')) {
            // My events is active, so add Events.
            addHostedUserEventsToTab();
        }

        eventsTabEl.addEventListener('click', function() {
            // My Events Tab selected, so add Events.
            addHostedUserEventsToTab();
        });
    }

    function addHostedUserEventsToTab() {
        $.ajax({
            url: rnn.site.userEventsURL,
            method: "GET",
            success: function (data) {
                var $eventsTab = $("#my-events-tab");
                if($eventsTab.length) {
                    // append html to events tab.
                    try {
                        $eventsTab.html(data);
                    }
                    catch(error) {
                        // Error adding data to dom
                    }
                }
            },
            error: function(error) {
                // error
            }
        });
    }

    function populateFollow() {
        var followList = $('#my-profile-tab .following ul');
        var followUrls = [rnn.site.follow.viewTagsURL, rnn.site.follow.viewUsersURL, rnn.site.follow.viewSearchesURL];

        // If not on the profile tab then return
        if (!followList.length)
            return;

        // Only have subscriptions for an authenticated user
        rnn.modules.user.get(function (user) {
            if (user.authenticated) {
                $.each(followUrls, function(i, followUrl) {
                    $.ajax({
                        dataType: 'json',
                        url: followUrl,
                        success: function (data) {
                            var subscriptions = data.subscriptions;
                            var savedSearchCriteria = '';

                            if (typeof subscriptions != 'undefined' && subscriptions.length > 0) {
                                $.each(subscriptions, function(i, subscription) {
                                    switch (followUrl) {
                                        case rnn.site.follow.viewTagsURL:
                                            followList.append("<li class='following-pill' title='" + subscription.name  + "'><a href='" + subscription.subscription_url + "' class='track' data-track='{\"category\": \"My Account\", \"action\": \"view follow\", \"label\": \"tag\"}'><i class='icomoon-icon icon-tag'></i> " + subscription.name  + "</a></li>");
                                            break;
                                        case rnn.site.follow.viewUsersURL:
                                            followList.append("<li class='following-pill' title='" + subscription.name  + "'><a href='" + subscription.subscription_url + "' class='track' data-track='{\"category\": \"My Account\", \"action\": \"view follow\", \"label\": \"user\"}'><i class='tangram-icon icon-user'></i> " + subscription.name  + "</a></li>");
                                            break;
                                    }
                                });
                            }
                            else if (followUrl == rnn.site.follow.viewSearchesURL) {
                                $.each(data, function(i, savedSearch) {
                                    savedSearchCriteria = '';
                                    $.each(savedSearch.criteria, function(j, criteria) {
                                        if (savedSearchCriteria === '')
                                            savedSearchCriteria = criteria;
                                        else
                                            savedSearchCriteria += ', ' + criteria;
                                    });

                                    followList.append("<li class='following-pill' title='" + savedSearchCriteria  + "' data-subscription-id='" + savedSearch.subscription_id + "'><a href='" + savedSearch.results_url + "' class='track' data-track='{\"category\": \"My Account\", \"action\": \"view follow\", \"label\": \"user search\"}'><i class='tangram-icon icon-magnifier'></i> " + savedSearchCriteria  + "</a></li>");
                                });
                            }
                            rnn.modules.trackEvents.init();
                        }
                    });
                });
            }
        });
    }

    function populateActivityStream(activityFilter, lastPk) {
        var activityStream = $('#activity-stream-container .activities');
        var activityUrl = $('#activity-stream-container').data('activity-url');
        var moreActivityBtn = $('#activity-stream-container .more-activity');

        if (!activityUrl) {
            return;
        }

        if (typeof activityFilter === 'undefined' || activityFilter == 'all')
            activityFilter = '';
        else {
            activityFilter = 'all/' + activityFilter;

            // we need a trailing slash for these urls. This will make sure that there is one and only one:
            if (activityFilter.substr(-1) != '/') activityFilter += '/';
        }

        if (typeof lastPk === 'undefined')
            lastPk = '';

        $.ajax({
            url: activityUrl + activityFilter ,
            data: { is_ajax: '1', last_pk: lastPk },
            success: function (data) {
                if (lastPk !== '') {
                    $('#activity-stream-container .activities').append(data.user_actions);
                    moreActivityBtn.html('Load More Activity').prop('disabled', false);
                } else {
                    $('#activity-stream-container .activities').html(data.user_actions);
                }

                $('abbr.pubDate').timeago();

                if (data.has_next) {
                    moreActivityBtn.show();
                } else {
                    moreActivityBtn.hide();
                }
            },
            beforeSend: function () {
                if (lastPk !== '') {
                    moreActivityBtn.html('Loading...').prop('disabled', true);
                } else {
                    $('#activity-stream-container .activities').html("<p><img id='loader' src='" + rnn.site.mediaURL + "images/loader.gif' width='16px' /> Loading activity stream</p>");
                }
            }
        });
    }

    // Initialise Accounts
    function initAccounts() {
        initAvatarSelectors();
        initEmailConfirmationAlerts();

        if (location.hash !== '' && location.hash.length > 0)
            $('a[href="' + rnn.modules.utilities.selectorEscape(location.hash) + '-tab"]').tab('show');

        $('a[data-toggle="tab"]').on('click', function (e) {
            location.hash = $(this).data('hash');
        });

        $('a[href="#my-profile"]').on('click', function() {
            $('a[href="#my-profile-tab"]').tab('show');
            location.hash = 'my-profile';
        });

        $('.build-profile-button, .update-details').on('click', function() {
            $('a[href="#update-details-tab"]').tab('show');
            location.hash = 'update-details';
        });

        $('.my-subscription').on('click', function() {
            $('a[href="#subscription-tab"]').tab('show');
            location.hash = 'subscription';
        });

        $('.manage-notifications-button').on('click', function() {
            $('a[href="#notifications-tab"]').tab('show');
            location.hash = 'notifications';
        });

        $('#statements-modal').on('click', '.show-more-statements button', function() {
            $('#statements-modal ul li:hidden').show();
            $(this).parent().remove();
        });

        $('#statements-modal').on('show.bs.modal', function (e) {
            var subscriptionId = $(e.relatedTarget).data('subscription-id');
            var statementsList = $('#statements-modal ul');

            statementsList.html('<li>Loading Statements...</li>');

            $.ajax({
                dataType: 'json',
                url: rnn.site.chargifyStatementsURL + subscriptionId + '/',
                success: function (data) {
                    var statements = data;
                    var statementsHtml = '';

                    if (typeof statements != 'undefined' && statements.length > 0) {
                        $.each(statements, function(i, statement) {
                            statementsHtml += "<li>Tax Invoice #" + statement.statement_id + "<a class='" + (i === 0 ? "button-default-dark" : "button-default") + " pull-right' href='" + statement.pdf_url + "' target='_blank'>Download PDF</a></li>";
                        });
                    }
                    else {
                        statementsHtml = "<li>You currently don't have any statements</li>";
                    }

                    if (statements.length > 6)
                        statementsHtml += "<div class='show-more-statements'><button class='button-default-dark'>Show More</button></div>";

                    statementsList.html(statementsHtml);
                }
            });
        });

        $('#holiday-stop-modal').on('show.bs.modal', function (e) {
            var subscription = $(e.relatedTarget).data('subscription');
            var $emailLinks = $(this).find('a.email-subscriber-services, a[class*="button"]');
            var emailBody = encodeURIComponent("Dear Subscriber Services, \r\n\r\nI would like to request my Newspaper subscription be suspended whilst I'm on holidays. I have included my details below: \r\n\r\nName: " + subscription.user + "\r\nPhone: " + subscription.phone + "\r\nDelivery Address: " + subscription.address + "\r\n\r\nStop Date: \r\nRestart Date: \r\n\r\nThank you.");
            var holidayStopRequest = "mailto:subscriber@newsregionalmedia.com.au?subject=Subscription ID " + subscription.id + " - Holiday Stop Request&body=" + emailBody;

            $emailLinks.attr("href", holidayStopRequest);
        });

        $('.copy-activation-link').on('click', function() {
            var link = $(this).data('link');
            var tempInput = $("<input>");

            $("body").append(tempInput);
            tempInput.val(link).select();
            document.execCommand("copy");
            tempInput.remove();
        });

        $('.activity-filter').on('click', function(e) {
            e.preventDefault();

            var filterButton = $(this);
            var filter = filterButton.data('filter');
            var filterLabel = filterButton.html();
            var dropdownLink = $('.activity-dropdown');

            dropdownLink.html(filterLabel).data('filter', filter);
            $('.activity-filter').removeClass('active');
            filterButton.addClass('active');

            populateActivityStream(filter);
        });

        $('#activity-stream-container').on('click', '.more-activity', function(e) {
            var activityStream = $('#activity-stream-container .activities');
            var filter = $('.activity-dropdown').data('filter');
            var lastPk = activityStream.find('.activity').last().data('id');

            populateActivityStream(filter, lastPk);
        });

        $("#profile-picture").on("change", '#id_profile_image', function() {
            var files = !!this.files ? this.files : [];

            if (!files.length || !window.FileReader)
                return;

            if (/^image/.test(files[0].type)) {
                var reader = new FileReader();
                reader.readAsDataURL(files[0]);

                reader.onloadend = function() {
                    $('#id_profile_image').data("new-image", this.result);
                };
            }
        });

        $('body').on('submit', '#edit-profile-form form, #newsletters-form form, #update-details form', function (e) {
            e.preventDefault();
            var form = $(this);
            var container = $(this).closest('.row');
            var msg = 'There has been an error. Please refresh and try again';
            var msgStyle = 'alert-danger';
            var scrollPosition = 0;
            // Old alert wrapper vs new message container
            var $alertContainer = $('.alertWrapper') || $('.message-container', container);

            $('.control-group').removeClass('error');
            $('.input-error-message').remove();
            $alertContainer.html('');
            $('button[type="submit"]', form).prop('disabled', true).html('Saving...');

            $.ajax({
                url    : $(this).attr('action'),
                type   : 'post',
                data   : new FormData(this),
                processData: false,
                contentType: false,
                success: function(response) {
                    if (response.success === true) {
                        if (response.msg !== "")
                            msg = response.msg;
                        else
                            msg = "Thank you. Your changes have been saved successfully.";

                        msgStyle = 'alert-success';

                        var newImage = $('#id_profile_image').data("new-image");
                        var newName = $('#id_first_name').val() + ' ' + $('#id_last_name').val();
                        var newUsername = $('#id_username').val();

                        if (typeof newImage !== 'undefined' && newImage !== '') {
                            $('#profile-picture img, #my-account-top .avatar img').attr('src', newImage).attr('id', 'profileImg');
                            $('.nav .small-profile, .dropdown-menu .user-info .small-profile, .navmenu .navbar .userWrapper .small-profile').css('background-image', 'url(' + newImage + ')');
                            $('#id_profile_image').removeData("new-image");

                            var getImgOrientation = document.getElementById('profileImg');
                            var exifOrientation;

                            EXIF.getData(getImgOrientation, function() {
                                exifOrientation = EXIF.getTag(this, "Orientation");
                            });

                            if (exifOrientation === 3) {
                                $('#profile-picture img, #my-account-top .avatar, .nav .small-profile, .dropdown-menu .user-info .small-profile, .navmenu .navbar .userWrapper .small-profile').addClass('rotate-180');
                            } else if (exifOrientation === 6) {
                                $('#profile-picture img, #my-account-top .avatar, .nav .small-profile, .dropdown-menu .user-info .small-profile, .navmenu .navbar .userWrapper .small-profile').addClass('rotate-90');
                            } else if (exifOrientation === 8) {
                                $('#profile-picture img, #my-account-top .avatar, .nav .small-profile, .dropdown-menu .user-info .small-profile, .navmenu .navbar .userWrapper .small-profile').addClass('rotate-270');
                            } else {}

                            if (getImgOrientation.naturalWidth != getImgOrientation.naturalHeight) {
                                $('#profile-picture img').attr('width', '');
                            }
                        }

                        $('.nav span[data-user-property="display_name"], #my-account-top .profile-welcome .welcome-full-name').text(newName);
                        $('.dropdown-menu .user-info .user-details .username').text(newUsername);
                        $('#activity-stream-container').data('activity-url', rnn.site.profileURL + newUsername + '/');

                        $('#id_password, #id_password_confirm').val('');
                        $('#id_profile_image').replaceWith($('#id_profile_image').val('').clone(true));

                        $('*[data-user-property]').each(function () {
                          var $propEl, property, html;

                          $propEl = $(this);
                          property = $propEl.attr('data-user-property');

                          if (property == 'display_name') {
                            html = rnn.modules.utilities.niceWordTrunc(newName, 35);
                          } else {
                            html = newName;
                          }

                          $propEl.html(html || '');
                        });
                    }
                    else {
                        if (response.msg !== "")
                            msg = response.msg;

                        if (response.errors) {
                            $.each(response.errors, function(name, message) {
                                $('input[name=' + name + ']', form).closest('.control-group').addClass('error').append("<div class='input-error-message'>" + message + "</div>");
                            });

                            scrollPosition = $('.error:first').offset().top - 250;
                        }
                    }

                    $alertContainer.html("<div class='alert " + msgStyle + "'><button type='button' data-dismiss='alert' aria-hidden='true' class='close'>&times;</button>" + msg + "</div>");
                    $('button[type="submit"]', form).prop('disabled', false).html('Save Changes');

                    $('html, body').animate({
                        scrollTop: scrollPosition
                    }, 1000);

                },
                error: function () {
                    $alertContainer.html("<div class='alert " + msgStyle + "'><button type='button' data-dismiss='alert' aria-hidden='true' class='close'>&times;</button>" + msg + "</div>");
                    $('button[type="submit"]', form).prop('disabled', false).html('Save Changes');
                }
            });
         });
         // Remove "Manage Your Business" heading if there are no active business listings
         if ($('.isPublished_True').length >= 1) {
             $('.manage-your-business, .business-listings').removeClass('hide');
         }

         initialiseTopicSearch();
         populateFollow();
         populateActivityStream();
         populateMyEvents();
    }

    rnn = window.rnn;
    log = rnn.logging.log;
    titleVal = $('title').html();
    tally = 0;

    rnn.modules.register('accounts', {
        init: initAccounts,
        initEmailConfirmationAlerts: initEmailConfirmationAlerts
    });

})(jQuery);
